export default "__VITE_ASSET__0e4d401c__"